import { render, staticRenderFns } from "./ColumnAspects.vue?vue&type=template&id=a08b8484&scoped=true"
import script from "./ColumnAspects.vue?vue&type=script&lang=js"
export * from "./ColumnAspects.vue?vue&type=script&lang=js"
import style0 from "./ColumnAspects.vue?vue&type=style&index=0&id=a08b8484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08b8484",
  null
  
)

export default component.exports